import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EsignComponent } from './esign.component';
import { FormsModule } from '@angular/forms';
import { InputMaskDirective } from '../input-mask.directive';
//import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    InputMaskDirective
  ],
  declarations: [
    EsignComponent
  ],
  exports: [
    EsignComponent,
    InputMaskDirective
  ]
})
export class EsignModule { }
